"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _quarkCore = require("quark-core");

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var WarningButton = function WarningButton(_ref) {
  var unused = _objectWithoutProperties(_ref, []);

  return _react.default.createElement(_quarkCore.GetTheme, null, function (_ref2) {
    var red = _ref2.red,
        lightRed = _ref2.lightRed,
        darkRed = _ref2.darkRed,
        white = _ref2.white;
    return _react.default.createElement(_Text.default, _extends({
      disabledColor: lightRed,
      defaultColor: red,
      activeColor: darkRed,
      textColor: white
    }, unused));
  });
};

var _default = WarningButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/buttons/Warning/index.js
// module id = ./node_modules/quark-core/components/buttons/Warning/index.js
// module chunks = 0